import { getTheme, Stack, Text, TextField } from "@fluentui/react";
import { Controller, useFormContext } from "react-hook-form";

import { gbsAmountOptions } from "../../constants";

interface DataBonusFormValues {
  dataBonusGb: number;
}

export function LineAdditionalServiceDataBonusForm(): JSX.Element {
  const theme = getTheme();
  const { control, setValue, watch } = useFormContext<DataBonusFormValues>();
  const selectedDataBonusGb = watch("dataBonusGb");

  return (
    <Stack tokens={{ childrenGap: 8 }}>
      <Text styles={{ root: { fontWeight: 600 } }}>
        Volume de internet adicional
      </Text>
      <Text variant="small">Selecione o volume para o próximo ciclo.</Text>
      <Controller
        name="dataBonusGb"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            label="Quantidade"
            inputMode="numeric"
            maxLength={3}
            suffix="GB"
            value={field.value > 0 ? String(field.value) : ""}
            onChange={(_, value) => {
              const numericValue = (value ?? "").replace(/\D/g, "");

              field.onChange(numericValue ? Number(numericValue) : 0);
            }}
            errorMessage={fieldState.error?.message}
            required
            styles={{
              root: { maxWidth: 100 },
              suffix: { borderRadius: 5 }
            }}
          />
        )}
      />
      <Text variant="small">Sugestões:</Text>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          paddingBottom: 4
        }}
      >
        {gbsAmountOptions.map(option => {
          const isSelected = selectedDataBonusGb === option;

          return (
            <button
              key={option}
              type="button"
              onClick={() =>
                setValue("dataBonusGb", option, { shouldValidate: true })
              }
              style={{
                background: isSelected ? theme.palette.themePrimary : "white",
                border: `1px solid ${
                  isSelected
                    ? theme.palette.themePrimary
                    : theme.palette.neutralLight
                }`,
                borderRadius: 999,
                color: isSelected ? "white" : theme.palette.neutralPrimary,
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 600,
                minWidth: 56,
                padding: "6px 10px"
              }}
            >
              {option} GB
            </button>
          );
        })}
      </div>
    </Stack>
  );
}
